import { forwardRef, useId, useState } from 'react';
import { clsx } from 'clsx';
import { Icon } from '@shared/widgets';
import EyeIcon from '@assets/icons/eye.svg';
import CrossedEyeIcon from '@assets/icons/crossed-eye.svg';

interface IBaseInputProps {
  className?: string;
  label?: string;
  onlyPositive?: boolean;
  // BASE INPUT PROPS
  type?: 'number' | 'email' | 'password' | 'text';
  required?: boolean;
  isReadOnly?: boolean;
  placeholder?: string;
  minLength?: number;
  maxLength?: number;
  value?: string;
  onChange?: (data: string) => void;
  onBlur?: () => void;
}

export const BaseInput = forwardRef<HTMLInputElement, IBaseInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const id = useId();

  return (
    <div>
      {props.label && (
        <label htmlFor={id} className='w-full text-sm'>
          {props.label}
        </label>
      )}
      <div className={clsx('flex relative', props.className)}>
        <input
          ref={ref}
          id={id}
          className='flex w-full h-10 p-2 rounded border-b border-b-light focus:border-b-primary bg-ice dark:bg-soft-black hover:bg-white focus:outline-none font-light focus:font-normal text-sm focus:text-soft-black dark:focus:text-white'
          type={props.type === 'password' && showPassword ? 'text' : (props.type ?? 'text')}
          placeholder={props.required ? `${props.placeholder} *` : props.placeholder}
          required={props.required}
          readOnly={props.isReadOnly}
          minLength={props.minLength}
          maxLength={props.maxLength}
          value={props.value}
          onChange={(data) => props.onChange?.(data.target?.value ?? '')}
          onBlur={props.onBlur}
          onKeyDown={(e) => {
            if (props.onlyPositive && ['e', 'E', '+', '-'].includes(e.key)) e.preventDefault();
          }}
        />
        {props.type === 'password' && (
          <div className='absolute top-2 right-2' onClick={() => setShowPassword((prev) => !prev)}>
            <Icon icon={showPassword ? <EyeIcon /> : <CrossedEyeIcon />} />
          </div>
        )}
      </div>
    </div>
  );
});
